import { HttpResponseRecordProperty } from '@indigohive/cogfy-types'
import { FieldCellProps } from '../../FieldCell'
import { OptionChip, OptionChipColorName } from '../../../../components'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import { useWorkspaceSlug } from '../../../../hooks'

const getStatusColor = (status: string): OptionChipColorName => {
  if (status.startsWith('2')) {
    return 'green'
  } else if (status.startsWith('4')) {
    return 'red'
  }
  return 'red'
}

export type HttpResponseCellProps = Pick<FieldCellProps<HttpResponseRecordProperty>, 'collectionId' | 'record' | 'property' | 'textWrap'>

export function HttpResponseCell (props: HttpResponseCellProps) {
  const { property, textWrap } = props

  const value = property?.httpResponse?.value

  const statusColor = value?.status ? getStatusColor(value.status.toString()) : 'red'

  const body = value?.body
  const status = value?.status ?? ''
  const duration = value?.duration?.toFixed(0) ?? 0
  const workspace = useWorkspaceSlug()

  const formattedBody = body
    ? typeof body === 'string'
      ? body
      : JSON.stringify(body)
    : null

  return (
    <>
      {property?.httpResponse && (
        <Link
          to={`/${workspace}/${props.collectionId}/${props.record.id}`}
          className={clsx(
            'h-full',
            'w-full',
            'px-2',
            'py-1',
            'hover:bg-base-200',
            'active:bg-base-300',
            'text-gray-600',
            textWrap && 'whitespace-pre-wrap',
            !textWrap && 'truncate'
          )}
        >
          <div className={clsx('flex w-full gap-1', textWrap ? 'flex-wrap flex-col' : 'flex-nowrap')}>
            <div className='flex items-center gap-1'>
              <OptionChip color={statusColor} label={status.toString()} />
              <span className='opacity-70 text-xs'>{duration}ms</span>
            </div>
            <span>
              {textWrap ? formattedBody?.replace('\n', ' ') : formattedBody}
            </span>
          </div>
        </Link>
      )}
    </>
  )
}
